export function generateCourierCode()
{
    return({
        type:"GENERATE_COURIER_CODE"
    })
}